import React from "react"
import { Container, Row, Col } from "reactstrap"
import CookieSettingsLink from "../Common/CookieSettingsLink"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md={12} className="text-center">
              {new Date().getFullYear()} © <a href={process.env.REACT_APP_FRONTEND_URL} target="_blank" rel="noreferrer">Tokenized Green.</a>
              <span className="mx-2">·</span>
              <CookieSettingsLink className="text-muted" />
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
